import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/blog/debarras-appartement-bruxelles-guide/PageClient.jsx");
